import React from 'react';
import { ProductId } from 'services/products/types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import { numberOfDays } from 'utils/formatter/number-of-days';
import { AppState } from 'services/types';
import ListItem from 'components/ListItem';
import { makeSelectReEntryPeriodDays } from './selectors';

interface ConnectedProps {
    reEntryPeriod: number;
}

interface OwnProps {
    productId: ProductId;
}

export type Props = ConnectedProps & OwnProps;

export class ReEntryPeriodListItemComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { reEntryPeriod } = this.props;

        return (
            <ListItem
                value={numberOfDays(reEntryPeriod)}
                description="Re-entry period"
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    reEntryPeriod: makeSelectReEntryPeriodDays()
});

export default connect(mapStateToProps)(ReEntryPeriodListItemComponent);
